var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    viewBox: "0 0 57 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2288 15.7336C30.2288 18.3926 28.0635 20.5576 25.4043 20.5576C22.7453 20.5576 20.5803 18.3927 20.5803 15.7336C20.5803 13.0741 22.7453 10.9092 25.4043 10.9092C28.0634 10.9092 30.2288 13.0742 30.2288 15.7336ZM28.8128 15.7336C28.8128 13.8532 27.2847 12.3251 25.4043 12.3251C23.5242 12.3251 21.9963 13.8533 21.9963 15.7336C21.9963 17.6136 23.5244 19.1417 25.4043 19.1417C27.2846 19.1417 28.8128 17.6137 28.8128 15.7336Z",
    fill: "#807E8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8828 31.8624V1.41594H1.41594V37.3506L13.8655 24.901C14.0173 24.7492 14.214 24.6677 14.4287 24.6677C14.6435 24.6677 14.8409 24.7499 14.9928 24.9019L25.4055 35.3142L41.3069 19.4128C41.6165 19.1032 42.1231 19.1036 42.4331 19.4122L54.8828 31.8624ZM1.41594 39.353V46.5841H54.8833V33.8648L41.8701 20.8516L25.9678 36.7539C25.8163 36.9055 25.6194 36.9871 25.4055 36.9871C25.1914 36.9871 24.994 36.9055 24.841 36.7525L14.4287 26.3402L1.41594 39.353ZM1.12874 0H55.1701C55.7916 0 56.2988 0.507237 56.2988 1.12874V46.8713C56.2988 47.4928 55.7916 48 55.1701 48H1.12874C0.507237 48 0 47.4928 0 46.8713V1.12874C0 0.507237 0.507237 0 1.12874 0Z",
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.fdd05e43.svg";
export { ForwardRef as ReactComponent };